import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import { Save, Info } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

const FIELDS = [
  { k: "name", l: "Nome da escola", required: true },
  { k: "nickname", l: "Apelido" },
  { k: "cnpj", l: "CNPJ" },
  { k: "address", l: "Endereço completo" },
  { k: "city", l: "Cidade" },
  { k: "phone", l: "Telefone fixo" },
  { k: "whatsapp_director", l: "WhatsApp do diretor" },
  { k: "director_name", l: "Nome do diretor(a)" },
  { k: "director_email", l: "E-mail do diretor(a)" },
  { k: "email", l: "E-mail da escola" },
];

export default function SchoolProfile() {
  const { me, refreshMe } = useOutletContext();
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (me?.school) {
      const init = {};
      FIELDS.forEach((f) => (init[f.k] = me.school[f.k] || ""));
      setForm(init);
    }
  }, [me]);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name?.trim()) return toast.error("Nome da escola é obrigatório");
    setSaving(true);
    try {
      await api.patch("/school/profile", form);
      toast.success("Dados atualizados");
      await refreshMe();
    } catch (err) {
      toast.error("Erro ao salvar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-3xl space-y-5">
      <div>
        <h1 className="font-heading text-2xl font-black text-[#1e3a8a]">Meus dados</h1>
        <p className="text-sm text-slate-500">Mantenha os dados cadastrais da escola atualizados</p>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex gap-3">
        <Info className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
        <p className="text-xs text-amber-900">
          Use este espaço apenas para corrigir dados cadastrais (endereço, CNPJ, telefone, etc). Para outras mudanças
          cadastrais, entre em contato com a AMC Escolas.
        </p>
      </div>

      <form onSubmit={submit} className="bg-white rounded-2xl border border-slate-100 card-shadow p-6 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {FIELDS.map((f) => (
            <div key={f.k} className={f.k === "address" ? "md:col-span-2" : ""}>
              <label className="block text-xs font-semibold text-slate-700 mb-1.5">
                {f.l} {f.required && <span className="text-red-500">*</span>}
              </label>
              <input
                type="text"
                value={form[f.k] || ""}
                onChange={(e) => setForm({ ...form, [f.k]: e.target.value })}
                data-testid={`s-profile-${f.k}`}
                className="w-full h-11 px-3 rounded-xl border border-slate-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-[#7c3aed]"
              />
            </div>
          ))}
        </div>
        <div className="flex justify-end pt-3 border-t border-slate-100">
          <Button type="submit" disabled={saving} className="bg-[#7c3aed] hover:bg-[#6d28d9] text-white" data-testid="s-profile-save">
            <Save className="w-4 h-4 mr-2" />
            {saving ? "Salvando..." : "Salvar alterações"}
          </Button>
        </div>
      </form>
    </div>
  );
}
